import React, { Component, Fragment } from 'react'
import Img from '@UI/Img'
import style from './style.module.less'
import { Flex } from 'hljd'

export default class extends Component {
  render() {
    const { sample, fake, is_sample_related_work } = this.props
    const imgStyle = {
      width: 84,
      height: 48,
      marginRight: 3,
      backgroundColor: '#eee',
      flexShrink: 0
    }

    return (
      <Flex className={style.related}>
        <p style={{ flexShrink: 0 }}>
          {is_sample_related_work ? (
            <span>
              关联
              <br />
              客照
            </span>
          ) : (
            <span>
              案例
              <br />
              图集
            </span>
          )}
        </p>

        {fake ? (
          <Fragment>
            <div style={imgStyle} />
            <div style={imgStyle} />
            <div style={imgStyle} />
          </Fragment>
        ) : (
          <Flex>
            {(sample || [])
              .slice(0, 3)
              .map(({ id, cover_path }) => (
                <Img key={id} style={imgStyle} src={cover_path} />
              ))}
          </Flex>
        )}
      </Flex>
    )
  }
}
